import { DEFAULT_COUNTER_ORDER_TYPES } from "../models/CounterOrderType.js";
import { TABLE_LABEL_MAX, validateTableLabel } from "../models/TableLabel.js";
import { ViewModel } from "../mvvm/ViewModel.js";
export const DEFAULT_FLOW_ORDER_TYPES = [
    { id: "walk_in", labelKey: "counter.orderType.walkIn" },
    { id: "online", labelKey: "counter.orderType.online" },
];
/** Marketplace channels: the counter list without the in-house "counter" entry. */
export const DEFAULT_FLOW_CHANNELS = DEFAULT_COUNTER_ORDER_TYPES.filter((t) => t.id !== "counter");
export const DEFAULT_TABLE_MAX_LENGTH = TABLE_LABEL_MAX;
const STEP_FOR = {
    walk_in: "done",
    for_here: "enter_table",
    to_go: "choose_to_go",
    online: "choose_channel",
};
export class OrderTypeFlowViewModel extends ViewModel {
    constructor(options = {}) {
        super({
            step: "choose_type",
            types: options.types ?? DEFAULT_FLOW_ORDER_TYPES,
            channels: options.channels ?? DEFAULT_FLOW_CHANNELS,
            orderType: null,
            tableInput: "",
            tableMaxLength: options.tableMaxLength ?? DEFAULT_TABLE_MAX_LENGTH,
            error: null,
            result: null,
        });
    }
    chooseType(id) {
        if (!this.state.types.some((t) => t.id === id))
            return;
        if (id !== "for_here" && id !== "to_go" && id !== "online" && id !== "walk_in")
            return;
        if (id === "walk_in") {
            this.setState({ orderType: id, error: null });
            this.finish({ orderType: "walk_in", fulfilmentMode: "asap", payLater: false });
            return;
        }
        const step = STEP_FOR[id];
        this.setState({ orderType: id, step, error: null, result: null });
    }
    setTable(value) {
        this.setState({ tableInput: value, error: null });
    }
    confirmTable() {
        if (this.state.step !== "enter_table")
            return null;
        const { label, error } = validateTableLabel(this.state.tableInput, this.state.tableMaxLength);
        if (error) {
            this.setState({ error });
            return null;
        }
        return this.finish({ orderType: "for_here", fulfilmentMode: "asap", tableLabel: label, payLater: false });
    }
    /** To go: a call-in is paid later, a walk-in pays now. */
    chooseToGo(callIn) {
        if (this.state.step !== "choose_to_go")
            return null;
        return this.finish({ orderType: "to_go", fulfilmentMode: "asap", payLater: callIn });
    }
    chooseChannel(channelId) {
        if (this.state.step !== "choose_channel")
            return null;
        if (!this.state.channels.some((c) => c.id === channelId))
            return null;
        return this.finish({ orderType: "online", fulfilmentMode: "asap", channel: channelId, payLater: false });
    }
    back() {
        this.setState({ step: "choose_type", orderType: null, tableInput: "", error: null, result: null });
    }
    finish(result) {
        this.setState({ step: "done", result, error: null });
        return result;
    }
}
//# sourceMappingURL=OrderTypeFlowViewModel.js.map